import { API_ROUTES, ApiService } from '@shared/api-utils';
import { getConfig } from '@shared/utils';
import type { ScratchcardDetails, ScratchcardPayTable, ScratchcardPayTablesResponse, ScratchcardsApiResponse } from '../types';
import { resolveScratchcardByMappingPath, resolveScratchcardPayTable } from '../utils/resolveScratchcardProduct';

type FetchScratchcardProductResult = {
  scratchcard: ScratchcardDetails;
  payTables: ScratchcardPayTable[];
};

async function fetchScratchcardProduct(scratchcardName: string): Promise<FetchScratchcardProductResult | null> {
  const { apiUrl, apiLocale, apiKey, currency } = getConfig();
  const apiService = ApiService.getInstance(apiUrl);
  const apiHeaders = { headers: { 'x-api-key': apiKey } };

  const listPath = API_ROUTES.SCRATCHCARDS.LIST.replace(':currency', currency).replace(':locale', apiLocale);
  const payTablesPath = API_ROUTES.SCRATCHCARDS.PAYTABLES.replace(':currency', currency).replace(':locale', apiLocale);

  const [{ data: scratchcards }, { data: payTablesResponse }] = await Promise.all([
    apiService.get<ScratchcardsApiResponse>(listPath, apiHeaders),
    apiService.get<ScratchcardPayTablesResponse>(payTablesPath, apiHeaders),
  ]);

  if (!scratchcards?.length) {
    return null;
  }

  const scratchcard = resolveScratchcardByMappingPath(scratchcards, scratchcardName);
  if (!scratchcard) {
    return null;
  }

  return {
    scratchcard,
    payTables: resolveScratchcardPayTable(payTablesResponse, scratchcard),
  };
}

export { fetchScratchcardProduct, type FetchScratchcardProductResult };
